import { render, staticRenderFns } from "./UserReferralReferralsExtra.vue?vue&type=template&id=502d09e8&"
import script from "./UserReferralReferralsExtra.vue?vue&type=script&lang=js&"
export * from "./UserReferralReferralsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports